<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryButtonHidden]="true" modalClass="select-associated-review-project-modal">

    <div class="description-text">Multiple Review Projects are associated with this Project.<br>
        Select the Review Project to open:</div>

    <ul class="review-project-list">
        <li *ngFor="let project of reviewProjects" (click)="selectProject(project)"
            [attr.data-automation-id]="modalAutomationId + '-project-' + project.reviewProjectId">
            <span class="review-project-icons">
                <i class="fa fa-clone"
                    [ngClass]="reviewSystem === ReviewSystem.REEF_REVIEW ? 'reef-review-icon-color' : 'relativity-icon-color'"></i>
                <span [ngClass]="reviewSystem === ReviewSystem.REEF_REVIEW ? 'reef-review-span-color' : 'relativity-span-color'">R</span>
            </span>
            <span class="project-name">{{ project.reviewProjectName }}</span>
        </li>
    </ul>
</res-base-modal>
